import { useState, useEffect } from "react";

import Agenda from "../../../components/Engage/Agenda";
import Loading from "../../../components/Shared/Loading";
import EngageSideBar from "../../../components/Layout/EngageSideBarNS";
import EngageMenuButton from "../../../components/Layout/EngageMenuButtonNS";

function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}

export default function AgendaDetails() {
  const isMounted = useMounted();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="h-screen flex overflow-hidden bg-white">
      {isMounted ? (
        <>
          <EngageSideBar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            path="agendas"
          />
          <div className="flex flex-col w-0 flex-1 lg:overflow-hidden">
            <EngageMenuButton setSidebarOpen={setSidebarOpen} />
            <main className="flex-1 relative overflow-y-auto focus:outline-none">
              <Agenda />
            </main>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}
